import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { requestUSAPost } from 'modules/fetch/api';
import { activeModal } from 'modules/actions/statusMenu';
import moment from 'moment';

const SEND_USA_STAR_SCORE = 'starUsability/SEND_USA_STAR_SCORE';
const SET_RESPONSE = 'quality/SET_RESPONSE';

// 2024.7.22 사용자 편의성 조사
export const sendUsaAbility = createAction(SEND_USA_STAR_SCORE);
export const setResponse = createAction(SET_RESPONSE);

// let botId = '';
const initialState = {
  answer: {
    type_1:
      {
        type: '1',
        sub_type: '1',
        score: 5,
        grade: 100,
        content: '매우 그렇다',
      },
    type_2: {
      type: '2',
      sub_type: '1',
      score: 5,
      grade: 100,
      content: '매우 그렇다',
    },
    type_3:
      {
        type: '3',
        sub_type: '1',
        score: 5,
        grade: 100,
        content: '매우 그렇다',
      }
  },
  id:{
    botId:""
  }
};

export function* sendUsaAbilityaction(action) {
  // 함수호출시
  const paramSet = {
    user_id: sessionStorage.getItem('user_id'),
    in_type: 'usability',
    session_id: sessionStorage.getItem('session_id'),
    channel_id: sessionStorage.getItem('device'),
    usability: action.payload.answer,
  };

  const response = yield call(requestUSAPost, paramSet);
	yield put(setResponse([{text:"소중한 의견을 남겨주셔서 감사합니다."}]));
	yield put(activeModal('feedbackResponseModal'));
}

const usability = handleActions(
  {
    [SEND_USA_STAR_SCORE]: (state, { payload }) => {
      return {
        ...state,
        answer: {
          ...state.answer,
          ...payload.answer // payload.answer로 answer 업데이트
        },
        id: {
          ...state.id,
          ...payload.id // payload.id로 id 업데이트
        }
      };
    }
  },
  initialState
);

export function* sendUsaAbilityactionSaga() {
  // 처음 렌더 시 미들웨어 호출
  yield takeLatest(SEND_USA_STAR_SCORE, sendUsaAbilityaction);
}

export default usability;
